<template>
  <div class="modal-mask" @mousedown.self.stop="clearAndCloseModal">
    <div class="modal event-create" @click.stop="closeRecipientsSelect">
      <div class="modal__aside">
        <div v-if="false" class="modal__a-item">
          <button :class="['notification', {notification__off: !notification}]" @click="notification = !notification">
            <svg v-if="!notification" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.56401 5.70385L3.5284 5.80476C3.32433 6.38289 3.30112 6.94987 3.27951 7.66817C3.27906 7.68292 3.27862 7.69772 3.27818 7.71257C3.24747 8.73945 3.20958 10.0062 2.26727 11.3349C1.72899 12.0938 1.39435 12.8277 1.19084 13.3948H14.0317C13.8282 12.8277 13.4936 12.0938 12.9553 11.3349C12.013 10.0062 11.9751 8.73944 11.9444 7.71257C11.944 7.69772 11.9435 7.68292 11.9431 7.66817C11.9214 6.94826 11.8981 6.38022 11.6928 5.80084L11.6571 5.70004L11.6456 5.5937C11.4762 4.02333 9.85044 2.58608 7.61068 2.58608C5.36906 2.58608 3.74267 4.02555 3.57534 5.59744L3.56401 5.70385ZM14.9958 13.3948C15.1733 13.9537 15.2226 14.3082 15.2226 14.3082H0C0 14.3082 0.049274 13.9537 0.226801 13.3948C0.436435 12.7348 0.824905 11.7897 1.52226 10.8065C2.30449 9.70354 2.33547 8.6741 2.36656 7.6407C2.38773 6.93736 2.40895 6.23218 2.66712 5.50076C2.89559 3.3545 5.02166 1.67273 7.61068 1.67273C10.1977 1.67273 12.3225 3.35189 12.5537 5.49575C12.8135 6.22897 12.8348 6.93576 12.856 7.6407C12.8871 8.6741 12.9181 9.70354 13.7003 10.8065C14.3977 11.7897 14.7862 12.7348 14.9958 13.3948Z" fill="#0E619F"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.73729 13.8383C4.70272 14.0086 4.68457 14.1849 4.68457 14.3653C4.68457 15.8204 5.86416 17 7.31925 17C8.77434 17 9.95393 15.8204 9.95393 14.3653C9.95393 14.1849 9.93578 14.0086 9.90121 13.8383H8.95839C9.01176 14.0044 9.04057 14.1815 9.04057 14.3653C9.04057 15.316 8.26991 16.0867 7.31925 16.0867C6.36859 16.0867 5.59793 15.316 5.59793 14.3653C5.59793 14.1815 5.62674 14.0044 5.6801 13.8383H4.73729Z" fill="#6F38A0"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.59793 14.3653C5.59793 14.4982 5.61297 14.6275 5.64145 14.7517C5.8168 15.5163 6.50142 16.0867 7.31925 16.0867C8.13708 16.0867 8.8217 15.5163 8.99705 14.7517C9.02553 14.6275 9.04057 14.4982 9.04057 14.3653C9.04057 14.3565 9.04051 14.3476 9.04037 14.3388C9.03773 14.1644 9.00918 13.9964 8.95839 13.8383L9.90102 13.8383C9.93225 13.9921 9.95025 14.1507 9.95341 14.313C9.95376 14.3304 9.95393 14.3479 9.95393 14.3653C9.95393 15.8204 8.77434 17 7.31925 17C5.86416 17 4.68457 15.8204 4.68457 14.3653C4.68457 14.1849 4.70272 14.0086 4.73729 13.8383H5.6801C5.62674 14.0044 5.59793 14.1815 5.59793 14.3653Z" fill="#0E619F"/>
              <path d="M8.69858 1.08733C8.69858 1.68784 8.21177 2.17466 7.61125 2.17466C7.01074 2.17466 6.52393 1.68784 6.52393 1.08733C6.52393 0.486813 7.01074 0 7.61125 0C8.21177 0 8.69858 0.486813 8.69858 1.08733Z" fill="#0E619F"/>
            </svg>
            <svg v-else width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.56401 5.70385L6.5284 5.80476C6.32433 6.38289 6.30112 6.94987 6.27951 7.66817C6.27906 7.68292 6.27862 7.69772 6.27818 7.71257C6.24747 8.73945 6.20958 10.0062 5.26727 11.3349C4.72899 12.0938 4.39435 12.8277 4.19084 13.3948H17.0317C16.8282 12.8277 16.4936 12.0938 15.9553 11.3349C15.013 10.0062 14.9751 8.73944 14.9444 7.71257C14.944 7.69772 14.9435 7.68292 14.9431 7.66817C14.9214 6.94826 14.8981 6.38022 14.6928 5.80084L14.6571 5.70004L14.6456 5.5937C14.4762 4.02333 12.8504 2.58608 10.6107 2.58608C8.36906 2.58608 6.74267 4.02555 6.57534 5.59744L6.56401 5.70385ZM17.9958 13.3948C18.1733 13.9537 18.2226 14.3082 18.2226 14.3082H3C3 14.3082 3.04927 13.9537 3.2268 13.3948C3.43643 12.7348 3.82491 11.7897 4.52226 10.8065C5.30449 9.70354 5.33547 8.6741 5.36656 7.6407C5.38773 6.93736 5.40895 6.23218 5.66712 5.50076C5.89559 3.3545 8.02166 1.67273 10.6107 1.67273C13.1977 1.67273 15.3225 3.35189 15.5537 5.49575C15.8135 6.22897 15.8348 6.93576 15.856 7.6407C15.8871 8.6741 15.9181 9.70354 16.7003 10.8065C17.3977 11.7897 17.7862 12.7348 17.9958 13.3948Z" fill="#8CA4B7"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73729 13.8383C7.70272 14.0085 7.68457 14.1848 7.68457 14.3653C7.68457 15.8204 8.86416 17 10.3192 17C11.7743 17 12.9539 15.8204 12.9539 14.3653C12.9539 14.1848 12.9358 14.0085 12.9012 13.8383H11.9584C12.0118 14.0044 12.0406 14.1815 12.0406 14.3653C12.0406 15.3159 11.2699 16.0866 10.3192 16.0866C9.36859 16.0866 8.59793 15.3159 8.59793 14.3653C8.59793 14.1815 8.62674 14.0044 8.6801 13.8383H7.73729Z" fill="#6F38A0"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.59793 14.3653C8.59793 14.4981 8.61297 14.6274 8.64145 14.7516C8.8168 15.5163 9.50142 16.0866 10.3192 16.0866C11.1371 16.0866 11.8217 15.5163 11.997 14.7516C12.0255 14.6274 12.0406 14.4981 12.0406 14.3653C12.0406 14.3564 12.0405 14.3475 12.0404 14.3387C12.0377 14.1644 12.0092 13.9963 11.9584 13.8383L12.901 13.8383C12.9322 13.992 12.9503 14.1507 12.9534 14.3129C12.9538 14.3303 12.9539 14.3478 12.9539 14.3653C12.9539 15.8204 11.7743 17 10.3192 17C8.86416 17 7.68457 15.8204 7.68457 14.3653C7.68457 14.1848 7.70272 14.0085 7.73729 13.8383H8.6801C8.62674 14.0044 8.59793 14.1815 8.59793 14.3653Z" fill="#8CA4B7"/>
              <path d="M11.6986 1.08733C11.6986 1.68784 11.2118 2.17466 10.6113 2.17466C10.0107 2.17466 9.52393 1.68784 9.52393 1.08733C9.52393 0.486813 10.0107 0 10.6113 0C11.2118 0 11.6986 0.486813 11.6986 1.08733Z" fill="#8CA4B7"/>
              <path d="M18.5 3L1 16" stroke="#8CA4B7"/>
            </svg>
            {{notification ? 'Не оповещать о решении' : 'Оповещать о решении'}}
          </button>
        </div>

        <div class="modal__a-item">
          <AppInputDate :timer="true"
                        title="Дата и время начала:"
                        width="100%"
                        :value="state.date_start"
                        type="single"
                        :valid="{}"
                        @value-changed="setStartDate"
          />
        </div>

        <div class="modal__a-item">
          <AppInputDate title="Дата и время завершения"
                        :value="state.date_finish"
                        width="100%"
                        type="single"
                        :timer="true"
                        :valid="{}"
                        @value-changed="setFinishDate"
          />
        </div>

        <div class="modal__a-item">
          <AppCheckbox title="На весь день"
          />
        </div>

        <div class="modal__a-item">
          <AppInput title="Место проведения:"
                    width="100%"
                    :value="state.place"
                    :valid="{}"
                    @value-changed="setPlace"
          />
        </div>

        <div class="modal__a-item" :class="!state.recipients.active ? 'z-index-high' : ''">
          <AppSelect
            title="Время напоминания"
            :options="state.reminder.options"
            placeholder="Выберите время напоминания"
            :value="state.reminder.value"
            @value-changed="setReminder"
            width="100%"
          />
        </div>

        <div class="modal__a-item">
          <p class="members__title">Участники</p>
          <AppMessageRecipients :is-active="state.recipients.active"
                                :state="state.recipients"
                                width="100%"
                                @setUserSearch="setUserRecipientSearch"
                                @toggle-check-recipient="toggleRecipient"
                                @toggle="toggleRecipientsSelect"
                                @close="closeRecipientsSelect"
          />
        </div>

        <div class="modal__a-item modal__users-item">

          <transition name="fade">
            <div class="modal__more-users-wrap" v-if="state.activeMoreUsers">

              <ul class="modal__more-users">
                <li class="modal__m-user" v-for="rec in state.recipients.selected.slice(6)" :key="rec.id">
                  <template v-if="isUserTag(rec.recipient_id)">
                    <img v-if="rec.avatar !== null && rec.avatar"
                         :src="rec.avatar.url" :alt="`${rec.profile ? rec.profile.surname : ''} ${rec.profile ? rec.profile.name : ''} ${rec.profile ? rec.profile.patronymic : ''}`">
                    <img v-else src="/img/avatar-thumb.png" :alt="`${rec.profile ? rec.profile.surname : ''} ${rec.profile ? rec.profile.name : ''} ${rec.profile ? rec.profile.patronymic : ''}`">
                  </template>
                  <template v-else>
                    <img src="/img/system-avatar.svg" :alt="rec.name">
                  </template>

                  <div class="tooltip">
                    <transition name="fade">
                      <div class="tooltip__block tooltip__right">
                        {{ isUserTag(rec.recipient_id) ? rec.profile.full_name : rec.name }}
                      </div>
                    </transition>
                  </div>

                  <div class="modal__user-delete" @click.stop="toggleRecipient(rec)">
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L5 5" stroke="white"/>
                      <path d="M1 5L5 1" stroke="white"/>
                    </svg>
                  </div>
                </li>

              </ul>
            </div>
          </transition>

          <ul class="modal__users">
            <transition name="fade" v-for="rec in state.recipients.selected.slice(0, 6)" :key="rec.id">

              <li class="modal__user" @click.stop="openUserDetail(rec.id)">
                <template v-if="isUserTag(rec.recipient_id)">
                  <img v-if="rec.avatar !== null && rec.avatar"
                       :src="rec.avatar.url" :alt="`${rec.profile ? rec.profile.surname : ''} ${rec.profile ? rec.profile.name : ''} ${rec.profile ? rec.profile.patronymic : ''}`">
                  <img v-else src="/img/avatar-thumb.png" :alt="`${rec.profile ? rec.profile.surname : ''} ${rec.profile ? rec.profile.name : ''} ${rec.profile ? rec.profile.patronymic : ''}`">
                </template>
                <template v-else>
                  <img src="/img/system-avatar.svg" :alt="rec.name">
                </template>
                <div class="tooltip">
                  <transition name="fade">
                    <div class="tooltip__block tooltip__right">
<!--                      {{ rec.profile ? rec.profile.full_name : rec.profile.name ?  }}-->
                      {{ isUserTag(rec.recipient_id) ? rec.profile.full_name : rec.name }}
                    </div>
                  </transition>
                </div>

                <div class="modal__user-delete" @click.stop="toggleRecipient(rec)">
                  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5" stroke="white"/>
                    <path d="M1 5L5 1" stroke="white"/>
                  </svg>
                </div>
              </li>
            </transition>

            <li class="modal__all-users" v-if="state.recipients.selected.length > 6" @click.stop="openEventMoreUsers">
              Все
            </li>
          </ul>
        </div>
      </div>

      <div class="modal__body">
        <div class="head">
          <h3 class="title event-create__title">{{ `${state.updatedId ? 'Редактировать' : 'Создать'} мероприятие${state.updatedId ? `: ${state.name}` : ''}` }}</h3>
          <div class="close" @click.stop="clearAndCloseModal">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
              <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
        </div>
        <div class="description">
          <div class="event-create__name">
            <AppInput :value="state.name"
                      :valid="state.validation.name"
                      title="Название"
                      width="100%"
                      @value-changed="setName"
                      @got-focus="clearValidation"
            />
          </div>
          <h4 class="input__text">Описание</h4>
          <div class="description__inner">
            <AppMessageInput not-message
                             :value="state.description"
                             placeholder="Описание мероприятия"
                             textarea-height="72px"
                             @value-changed="setDescription"
                             @selection-range="setInputSelectionRange"
                             @paste-files="attachFiles"
            />
            <div class="description__attachment-preview" v-if="(state.attachment.files && state.attachment.files.length !== 0) || (state.attachment.files && state.attachment.tags.length !== 0)">
              <AppMessageAttachmentPreview :files="state.attachment.files"
                                           :tags="state.attachment.tags"
                                           :editable="true"
                                           @remove-file="removeFile"
                                           @remove-tag="removeTag"
              />
            </div>
            <div class="description__attachment">
              <AppMessageAttachment :link-tooltip="state.attachment.linkTooltip"
                                    :tag-tooltip="state.attachment.tagTooltip"
                                    @toggle-link-tooltip="toggleLinkTooltip"
                                    @close-link-tooltip="closeLinkTooltip"
                                    @set-link-url="setLinkUrl"
                                    @toggle-tag-tooltip="toggleTagTooltip"
                                    @close-tag-tooltip="closeTagTooltip"
                                    @set-tag-text="setTagText"
                                    @attach-files="attachFiles"
                                    @attach-link="attachLink"
                                    @attach-tag="attachTag"
                                    @clear-validation="clearAttachmentValidation"
              />
            </div>
          </div>
        </div>

        <Chart
          v-if="state.recipients.selected && state.recipients.selected.length"
          :users="state.recipients.selected"
          :date="new Date(state.date_start)"
          style="margin-bottom: 20px"
        />

        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton :title="state.updatedId ? 'Сохранить' : 'Создать'"
                        type="third"
                        :disabled="state.isLoading || !this.activeButton"
                        @click.native="saveEvent"

            />
          </div>
          <div class="modal__button">
            <AppButton title="Отмена"
                        type="alt"
                        :disabled="state.isLoading"
                        @click.native="clearAndCloseModal"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import AppInput from '@/components/page/input/AppInput'
import AppMessageAttachment from '@/components/page/input/AppMessageAttachment'
import AppSelect from '@/components/page/input/AppSelect'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppMessageRecipients from '@/components/page/input/AppMessageRecipients'
import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
import AppMessageInput from '@/components/page/input/AppMessageInput'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import Chart from '@/components/page/chart/ActivityChart'

export default {
  name: 'event-modal',
  components: {
    AppCheckbox,
    AppMessageInput,
    AppMessageAttachmentPreview,
    AppMessageRecipients,
    AppInputDate,
    AppSelect,
    AppMessageAttachment,
    AppInput,
    AppButton,
    Chart
  },
  data () {
    return {
      // для хранения ссылки на текущий инпут сообщения и его выделенной области
      messageInput: null,
      inputSelectionRange: null,
      activeButton: true,
      notification: false
    }
  },
  computed: {
    state () {
      return this.$store.getters.getFeedEventModal
    }
  },
  methods: {
    openEventMoreUsers () {
      this.$store.commit('ACTIVE_FEED_EVENT_MORE_USERS')
    },
    openUserDetail (userId) {
      this.$router.push({ path: `/user/info/${userId}/personal` })
    },
    saveEvent () {
      this.activeButton = false
      document.body.classList.add('loadingData')

      this.$store.dispatch('saveEvent').then(() => {
        this.activeButton = true
      })
    },
    clearAndCloseModal () {
      this.$store.dispatch('closeFeedEventModal')
      this.$store.dispatch('clearFeedEventModal')
    },
    setName (name) {
      this.$store.dispatch('setFeedEventName', name)
    },
    setDescription (description) {
      this.$store.dispatch('setFeedEventDescription', description)
    },
    toggleLinkTooltip () {
      this.$store.dispatch('feedEventModalToggleLinkTooltip')

      const range = this.inputSelectionRange
      if (range) {
        this.$store.dispatch('feedEventModalSetLinkText', range.toString())
      } else {
        this.$store.dispatch('feedEventModalSetLinkText', '')
      }
    },
    closeLinkTooltip () {
      this.$store.dispatch('feedEventModalCloseLinkTooltip')
    },
    setInputSelectionRange (data) {
      this.messageInput = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (!data.range.collapsed && (data.range.commonAncestorContainer.childElementCount === undefined || data.range.commonAncestorContainer.childElementCount === 0)) {
        this.inputSelectionRange = data.range
      } else {
        this.inputSelectionRange = null
      }
    },
    setLinkUrl (url) {
      this.$store.dispatch('feedEventModalSetLinkUrl', url)
    },
    toggleTagTooltip () {
      this.$store.dispatch('feedEventModalToggleTagTooltip')
    },
    closeTagTooltip () {
      this.$store.dispatch('feedEventModalCloseTagTooltip')
    },
    setTagText (text) {
      this.$store.dispatch('feedEventModalSetTagText', text)
    },
    attachFiles (files) {
      this.$store.dispatch('feedEventModalAttachFiles', files)
    },
    removeFile (data) {
      this.$store.dispatch('feedEventModalRemoveFile', data)
    },
    attachLink () {
      const range = this.inputSelectionRange
      const url = this.state.attachment.linkTooltip.url.indexOf('https://') + 1 ? this.state.attachment.linkTooltip.url : `https://${this.state.attachment.linkTooltip.url}`

      if (range && this.state.attachment.linkTooltip.url.length !== 0) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)
      }
      this.$store.dispatch('setFeedEventDescription', this.messageInput.innerHTML)
      this.$store.dispatch('feedEventModalAttachLink')
    },
    attachTag () {
      this.$store.dispatch('feedEventModalAttachTag')
    },
    removeTag (index) {
      this.$store.dispatch('feedEventModalRemoveTag', index)
    },
    clearAttachmentValidation () {},
    setStartDate (date) {
      this.$store.dispatch('setFeedEventStartDate', date)
    },
    setFinishDate (date) {
      this.$store.dispatch('setFeedEventFinishDate', date)
    },
    setPlace (place) {
      this.$store.dispatch('setFeedEventPlace', place)
    },
    setReminder (reminder) {
      this.$store.dispatch('setFeedEventReminder', reminder)
    },
    setUserRecipientSearch (value) {
      this.$store.dispatch('[feed-event] setUserRecipientSearch', value)
    },
    toggleRecipient (recipient) {
      this.$store.dispatch('toggleFeedEventRecipientSelected', recipient)
      if (this.$store.getters.getFeedEventModal.recipients.selected.length < 7) {
        this.$store.commit('CLOSE_FEED_EVENT_MORE_USERS')
      }
    },
    toggleRecipientsSelect () {
      this.$store.dispatch('toggleFeedEventRecipientsSelect')
    },
    closeRecipientsSelect () {
      this.$store.dispatch('closeFeedEventRecipientsSelect')
      this.$store.commit('CLOSE_FEED_EVENT_MORE_USERS')
    },
    clearValidation () {
      this.$store.dispatch('clearFeedEventValidation')
    },
    isUserTag (recipientId) {
      return recipientId.split('_').pop() === 'user'
    }
  },
  mounted () {
    this.$store.dispatch('[feed-event] getRecipientUserOptions')
    this.$store.dispatch('getFeedRecipientsOptions')
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 20px;
}

.modal {
  max-width: 1100px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  height: auto;

  &__aside {
    background: $color_sixth;
    width: 340px;
    padding: 34px 24px 46px;
    flex-shrink: 0;

    .notification {
      border: 1px solid #8CA4B7;
      box-sizing: border-box;
      border-radius: 3px;
      width: 100%;
      height: 40px;
      background: none;
      color: #8CA4B7;
      cursor: pointer;
      transition: .3s;

      &.notification__off {
        color: #0E619F;
        border: 1px solid #0E619F;
      }
    }
  }

  &__a-item {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__body {
    padding: 36px 40px 30px 46px;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
  }

  &__users-item {
    position: relative;
  }

  &__more-users-wrap {
    position: absolute;
    background: #ffffff;
    right: 0;
    bottom: 40px;
    z-index: 105;
    border: 1px solid #c4c4c4;
    padding: 14px 14px 0;
    border-radius: 3px;
    box-shadow: 0px 4px 4px rgba(23, 63, 125, 0.25);
    width: 250px;
  }

  &__more-users {
    display: flex;
    flex-wrap: wrap;

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: -6px;
      right: 32px;
      transform: translateX(-50%);
      margin: 0 auto;
      width: 10px;
      height: 10px;
      background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
      border: 1px solid $border_color;
      border-bottom: none;
      border-right: none;
      transform: rotate(-135deg);
      box-shadow: 2px 2px 0 1px $color_main,
      -2px 0px 3px rgba(0, 0, 0, 0.25);
    }
  }

  &__users {
    display: flex;
  }

  &__user-delete {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 16px;
    height: 16px;
    background: $font_color_third;
    border-radius: 50%;
    opacity: 0;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 8px;
      height: 8px;
    }
  }

  &__user,
  &__m-user{
    cursor: pointer;
    margin-right: 12px;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    padding: 3px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      margin-right: 0;
    }

    img {
      border-radius: 50%;
    }

    &::before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      background: transparent;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      border: 2px solid $color_second-border2;
    }

    &:hover {
      .tooltip__block {
        opacity: 1;
        pointer-events: all;
      }

      .modal__user-delete {
        opacity: 1;
      }
    }
  }

  .tooltip {
    position: relative;
    z-index: 999;
    cursor: pointer;
    left: -5px;

    &__right {
      max-width: 500px;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      top: auto;
      transition: all 0.2s;
      left: -11px;
      transform: translateX(-50%);
      right: auto;
      bottom: 26px;
      width: max-content;
      min-height: 50px;
      padding: 10px;
      color: $font_color_second;
      background-color: $color_main;
      border: 1px solid $border_color;
      border-radius: 3px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      //animation: fadeIn .3s ease-in;

      &:before {
        content: '';
        display: block;
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
        border: 1px solid $border_color;
        border-bottom: none;
        border-right: none;
        transform: rotate(-135deg);
        box-shadow: 2px 2px 0 1px $color_main,
        -2px 0px 3px rgba(0, 0, 0, 0.25);
      }
    }

    &:hover {
      .tooltip__right {
        display: block;
      }
    }
  }

  &__m-user {
    margin-bottom: 12px;
    margin-right: 10px;

    &:nth-child(6n) {
      margin-right: 0;
    }
  }

  &__all-users {
    color: $color_second-border2;
    font-size: 14px;
    letter-spacing: 0.04em;
    position: relative;
    padding-bottom: 2px;
    cursor: pointer;
    align-self: flex-end;
    line-height: 14px;

    &::before {
      position: absolute;
      bottom: 0;
      content: '';
      left: 0;
      transform: scaleX(1);
      width: 100%;
      height: 1px;
      transition: transform 0.3s;
      background: currentColor;
    }

    &:hover {
      &::before {
        transform: scaleX(0)
      }
    }
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: auto;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.head {
  display: flex;
}

.close {
  margin-left: auto;
  color: $color_third-dark;
  cursor: pointer;
  padding-right: 10px;

  &:hover {
    color: $color_second-light;
  }
}

.title {
  font-weight: bold;
  color: $font_color_third;
  font-size: 18px;
  margin-bottom: 20px;
}

.subtitle {
  font-weight: bold;
  margin-bottom: 20px;
}

.event-create {
  &__title {
    word-break: break-all;
    margin-bottom: 0;
  }

  &__name {
    margin-bottom: 40px;
  }
}

.description {
  margin-bottom: 36px;

  &__inner {
    padding: 16px 5px 24px;
    background: $color_main;
    border-radius: 3px;
    border: 1px solid $color_third-dark;
  }

  &__attachment {
    margin-top: 20px;
    padding-right: 15px;
    padding-left: 15px;
  }

  &__attachment-preview {
    background: $color_main;
    padding: 12px 15px 0;
  }
}

.body {
  padding: 40px 40px 50px;

  &__row {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 20px;
  }
}

.date-start {
  margin-right: 32px;
}

.members {

  &__title {
    margin-bottom: 10px;
    color: #697178;
  }
}

.input {
  &__text {
    display: block;
    margin-bottom: 10px;
    color: #697178;
  }
}

.z-index-high {
  position: relative;
  z-index: 99999;
}
</style>
